const LANGUAGE_LIST = {
  'zh-CN': {
    0: '活动不存在',
    '-1001': '操作过于频繁',
    '-10000': '参数错误',
    '-20002': '暂无角色',
    '-10001': '验证码不正确',
    '-10002': '游戏维护中，无法兑换奖励。',
    '-10004': '服务器维护中，无法兑换奖励。',
    '-10005': '角色不存在',
    '-10006': '虚宝号游戏不符！',
    '-10007': '领取次数过多',
    '-10008': '发送失败',
    '-10009': '请使用角色登入游戏后，再尝试',
    '-10010': '发送失败，请使用角色登入游戏后，再尝试',
    '-10011': '序号无法使用',
    '-10012': '序号已过期',
    '-10013': '序号已使用或不存在',
    '-20007': '该礼包码使用次数已达上限',
    10000: '发送成功',
    codePlaceholder: '请输入礼包序列号',
    verifyPlaceholder: '验证码',
    uidPlaceholder: '请输入UID',
    buttonText: '马上兑换',
    ruleTitle: '注意事项',
    ruleText: [
      '1.序列号激活后道具将发放至游戏内背包中',
      '2.请注意序列号的详细使用规则，以免出现激活失败的情况',
      '3.最终解释权归 {mainHostName} 运营团队所有',
    ],
    exchangeValError: '请输入礼包序列号',
    verifyCode: '请输入验证码',
    exchangeSucc: '兑换成功',
    exchangeTitle: '礼包码兑换',
    logout: '登出',
    logIn: '登入',
    gameDefault: '请选择游戏',
    serverDefault: '请选择服务器',
    roleDefault: '请选择角色名',
    gameEmpty: '游戏列表为空',
    serverEmpty: '服务器列表为空',
    roleEmpty: '还没有创建角色',
    server: '服务器:',
    noGameId: '该游戏礼包码兑奖功能维护中',
    failAction: '非法操作',
  },
  'zh-TW': {
    0: '活動不存在',
    '-1001': '操作過於頻繁',
    '-10000': '参数错误',
    '-20002': '暫無角色',
    '-10001': '驗證碼不正確',
    '-10002': '遊戲維護中，無法兌換獎勵。',
    '-10004': '服務器維護中，無法兌換獎勵。',
    '-10005': '角色不存在',
    '-10006': '虛寶號遊戲不符！',
    '-10007': '領取次數過多',
    '-10008': '發送失敗',
    '-10009': '請使用角色登入遊戲后，再嘗試',
    '-10010': '發送失敗，請使用角色登入遊戲后，再嘗試',
    '-10011': '序号无法使用',
    '-10012': '序号已过期',
    '-10013': '序号已使用或不存在',
    '-20007': '該禮包碼使用次數已達上限',
    10000: '發送成功',
    codePlaceholder: '請輸入禮包序列號',
    verifyPlaceholder: '驗證碼',
    uidPlaceholder: '請輸入UID',
    buttonText: '馬上兌換',
    ruleTitle: '注意事項',
    ruleText: [
      '1.序列號激活後道具將發放至遊戲內背包中',
      '2.請注意序列號的詳細使用規則，以免出現激活失敗的情況',
      '3.最終解釋權歸 {mainHostName} 運營團隊所有',
    ],
    exchangeValError: '請輸入禮包序列號',
    verifyCode: '請輸入驗證碼',
    exchangeSucc: '兌換成功',
    exchangeTitle: '禮包碼兌換',
    logout: '登出',
    logIn: '登入',
    gameDefault: '請選擇遊戲',
    serverDefault: '請選擇伺服器',
    roleDefault: '請選擇角色名',
    gameEmpty: '遊戲列表為空',
    serverEmpty: '伺服器列表為空',
    roleEmpty: '還沒有創建角色',
    server: '服務器:',
    noGameId: '該遊戲禮包碼兌獎功能維護中',
    failAction: '非法操作',
  },
  'ko-KR': {
    0: '활동이 존재하지 않습니다',
    '-1001': '잠시 후에 시도하세요',
    '-10000': '파라미터 오류',
    '-20002': '캐릭터 없음',
    '-10001': '인증코드가 맞지 않습니다',
    '-10002': '게임 점검 중...보상 교환할 수 없습니다',
    '-10004': '서버 점검 중입니다. 보상 교환할 수 없습니다',
    '-10005': '존재하지 않는 캐릭터입니다',
    '-10006': '맞지 않는 쿠폰번호입니다!',
    '-10007': '최대 수령 횟수에 도달했습니다',
    '-10008': '발송 실패',
    '-10009': '게임을 접속한 후에 재시도하세요',
    '-10010': '발송 실패. 게임을 접속한 후에 재시도하세요',
    '-10011': '사용할 수 없는 쿠폰번호입니다',
    '-10012': '쿠폰 유효 기간이 만료되었습니다',
    '-10013': '이미 사용했거나 존재하지 않는 쿠폰번호입니다',
    '-20007': '이미 사용된 쿠폰입니다',
    10000: '발송 성공',
    codePlaceholder: '쿠폰번호를 입력하세요',
    verifyPlaceholder: '인증 코드',
    uidPlaceholder: 'UID를 입력하세요',

    buttonText: '교환하기',
    ruleTitle: '주의사항',
    ruleText: [
      '1.보상은 인게임 가방으로 발송됩니다',
      '2.쿠폰의 사용 설명을 자세히 확인한 후에 사용하시기 바랍니다',
      '3.최종 해석권은 {mainHostName} 운영팀에 있습니다',
    ],
    exchangeValError: '패키지 일련 번호를 입력하십시오',
    verifyCode: '인증 코드를 입력하십시오',
    exchangeSucc: '수령 성공',
    exchangeTitle: '쿠폰등록',
    logout: '로그아웃',
    logIn: '로그인',
    gameDefault: '게임 선택',
    serverDefault: '서버를 선택하세요',
    roleDefault: '캐릭터명을 선택하세요',
    gameEmpty: '게임 리스트가 비어 있습니다',
    serverEmpty: '서버 리스트가 비어 있습니다',
    roleEmpty: '캐릭터 없음',
    server: '서버:',
    noGameId: 'Tính năng đổi quà đang bảo trì',

    failAction: '불법 연산',
  },
  'en-US': {
    0: 'Activity does not exist',
    '-1001': 'Request too frequently',
    '-10000': 'Parameter Error',
    '-20002': 'No character',
    '-10001': 'Invalid code',
    '-10002': 'Maintenance',
    '-10004': 'Maintenance',
    '-10005': 'Character not found',
    '-10006': 'Invalid game',
    '-10007': 'You may not claim again',
    '-10008': 'Failed to send',
    '-10009': 'Please log in and retry',
    '-10010': 'Failed to send. Retry later.',
    '-10011': 'Invalid serial number',
    '-10012': 'Serial number expired',
    '-10013': 'Serial number has been used',
    '-20007': 'Code has been used.',
    10000: 'Sent',
    codePlaceholder: 'enter gift code',
    verifyPlaceholder: 'type the text',
    uidPlaceholder: 'Insert UID',

    buttonText: 'Redeem',
    ruleTitle: 'Note',
    ruleText: [
      '1. Item will be sent to your bag in the game once the serial number has been used.',
      '2. Please read the rules carefully before using a serial number.',
      '3. {mainHostName} operation team reserves the right to interpret the policies of this event.',
    ],
    exchangeValError: 'Please enter the package serial number',
    verifyCode: 'please enter verification code',
    exchangeSucc: 'Successful redemption',
    exchangeTitle: 'GIFT CODE EXCHANGE',
    logout: 'Log Out',
    logIn: 'Log in',
    gameDefault: 'Select Game',
    serverDefault: 'Select server',
    roleDefault: 'Select character',
    gameEmpty: 'Game list is empty',
    serverEmpty: 'Server list is empty',
    roleEmpty: 'No character',
    server: 'Server:',
    noGameId: 'Tính năng đổi quà đang bảo trì',

    failAction: 'Illegal operation',
  },
  'vi-VN': {
    0: 'Hoạt động không tồn tại',
    '-1001': 'Thao tác quá dồn dập',
    '-10000': 'Tham số sai',
    '-20002': 'Không tồn tại nhân vật',
    '-10001': 'Mã xác nhận không chính xác',
    '-10002': 'Game đang bảo trì không thể đổi quà',
    '-10004': 'Server đang bảo trì không thể đổi quà',
    '-10005': 'Nhân vật không tồn tại',
    '-10006': 'Mã game không tồn tại!',
    '-10007': 'Số lần nhận quá nhiều',
    '-10008': 'Gửi thất bại',
    '-10009': 'Vui lòng đăng nhập nhân vật, rồi thử lại',
    '-10010': 'Gửi thất bại, hãy thử lại sau',
    '-10011': 'Mã không thể sử dụng',
    '-10012': 'Mã đã quá hạn',
    '-10013': 'Mã đã sử dụng hoặc không tồn tại',
    '-20007': 'Số lần dùng Code quà này đã đạt giới hạn',
    10000: 'Gửi thành công',
    codePlaceholder: 'Hãy nhập mã code',
    verifyPlaceholder: 'Mã xác minh',
    uidPlaceholder: 'Nhập UID',

    buttonText: 'Đổi ngay',
    ruleTitle: 'Chú ý',
    ruleText: [
      '1.Mã code kích hoạt quà sẽ được gủi đến túi của nhân vật trong game.',
      '2.Hãy chú ý quy tắc sử dụng mã đế tránh việc kích hoạt thất bại',
      '3.Quyền quyết định cuối cùng thuộc về {mainHostName}.',
    ],
    exchangeValError: 'Vui lòng nhập số sê-ri gói',
    verifyCode: 'Vui lòng nhập mã xác minh',
    exchangeSucc: 'Mua lại thành công',
    exchangeTitle: 'Trao đổi mã quà tặng',
    logout: 'Đăng xuất',
    logIn: 'Đăng nhập',
    gameDefault: 'Hãy chọn game',
    serverDefault: 'Hãy chọn Server',
    roleDefault: 'Hãy chọn nhân vật',
    gameEmpty: 'Danh sách game trống',
    serverEmpty: 'Danh sách Server trống',
    roleEmpty: 'Chưa tạo nhân vật',
    server: 'Máy chủ:',
    noGameId: 'Tính năng đổi quà đang bảo trì',

    failAction: 'Thao tác không hợp lệ',
  },
  'th-TH': {
    0: 'ไม่มีกิจกรรม',
    '-1001': 'ทำรายการบ่อยเกินไป',
    '-10000': 'ข้อมูลไม่ถูกต้อง',
    '-20002': 'ไม่มีตัวละคร',
    '-10001': 'รหัสยืนยันไม่ถูกต้อง',
    '-10002': 'กำลังปรับปรุงเกม จึงแลกรางวัลไม่ได้',
    '-10004': 'กำลังปรับปรุงเซิร์ฟเวอร์ จึงแลกรางวัลไม่ได้',
    '-10005': 'ไม่มีตัวละคร',
    '-10006': 'โค้ดรางวัลไม่สอดคล้องกับเกมที่เลือก!',
    '-10007': 'รับอีกไม่ได้แล้ว',
    '-10008': 'ส่งล้มเหลว',
    '-10009': 'โปรดใช้ตัวละครล็อกอิน แล้วลองใหม่',
    '-10010': 'ส่งล้มเหลว โปรดลองใหม่ภายหลัง',
    '-10011': 'ใช้โค้ดรางวัลไม่ได้',
    '-10012': 'โค้ดรางวัลหมดอายุแล้ว',
    '-10013': 'โค้ดรางวัลถูกใช้แล้วหรือไม่มีโค้ดนี้',
    '-20007': 'ใช้กิ๊ฟโค้ดนี้ถึงลิมิตแล้ว',
    10000: 'ส่งสำเร็จ',
    codePlaceholder: 'โปรดป้อนโค้ดรางวัล',
    verifyPlaceholder: 'รหัสยืนยัน',
    uidPlaceholder: 'โปรดป้อน UID',
    buttonText: 'แลก',
    ruleTitle: 'โปรดทราบ',
    ruleText: [
      '1.หลังเปิดโค้ดรางวัลจะส่งไอเทมให้ในเป้',
      '2.โปรดอ่านกติกาการใช้โค้ดรางวัลให้ละเอียด เพื่อป้องกันการเปิดโค้ดล้มเหลว',
      '3.{mainHostName} ขอสงวนสิทธิ์ในการเปลี่ยนแปลงเงื่อนไขต่างๆ โดยไม่ต้องแจ้งให้ทราบ',
    ],
    exchangeValError: 'กรุณาใส่หมายเลขซีเรียลของแพ็คเกจ',
    verifyCode: 'กรุณาใส่รหัสยืนยัน',
    exchangeSucc: 'ไถ่ถอนสำเร็จ',
    exchangeTitle: 'แลกเปลี่ยนรหัสของขวัญ',
    logout: 'ล็อกเอาต์',
    logIn: 'ล็อกอิน',
    gameDefault: 'โปรดเลือกเกม',
    serverDefault: 'โปรดเลือกเซิร์ฟเวอร์',
    roleDefault: 'โปรดเลือกตัวละคร',
    gameEmpty: 'รายชื่อเกมว่างเปล่า',
    serverEmpty: 'รายชื่อเซิร์ฟว่างเปล่า',
    roleEmpty: 'ยังไม่สร้างตัวละคร',
    server: 'เซิร์ฟ:',
    noGameId: 'Tính năng đổi quà đang bảo trì',

    failAction: 'ทำรายการไม่ถูกต้อง',
  },
  'tr-TR': {
    0: 'Etkinlik mevcut değil',
    '-1001': 'İstek yoğunluğu',
    '-10000': 'Parametro Hatası',
    '-20002': 'Karakter yok',
    '-10001': 'Geçersiz Kod',
    '-10002': 'Bakım',
    '-10004': 'Bakım',
    '-10005': 'Karakter bulunamadı',
    '-10006': 'Geçersiz oyun',
    '-10007': 'Tekrar toplayamazsın',
    '-10008': 'Gönderme başarısız',
    '-10009': 'Giriş yap ve tekrar dene',
    '-10010': 'Gönderme başarısız, daha sonra tekrar dene.',
    '-10011': 'Geçersiz seri numarası',
    '-10012': 'Seri numaranın tarihi geçti',
    '-10013': 'Seri numara önceden kullanılmış',
    '-20007': 'Kod kullanıldı',
    10000: 'Gönderildi',
    codePlaceholder: 'Seri numarayı girin',
    verifyPlaceholder: 'Doğrulama kodu',
    uidPlaceholder: 'Kullanıcı ID gir',

    buttonText: 'Kullan',
    ruleTitle: 'Not',
    ruleText: [
      '1. Seri numarası kullanıldığı zaman öğe oyun içi çantanıza gönderilecek.',
      '2. Bir seri numara kullanmadan önce lütfen kuralları dikkatlice okuyun.',
      '3. {mainHostName} operasyon ekibi, bu etkinliğin politikalarını yorumlama hakkını saklı tutar.',
    ],
    exchangeValError: 'Lütfen paketin seri numarasını girin',
    verifyCode: 'Lütfen doğrulama kodunu giriniz',
    exchangeSucc: 'Başarılı itfa',
    exchangeTitle: 'Hediye kodu değişimi',
    logout: 'Çıkış yap',
    logIn: 'Giriş yap',
    gameDefault: 'Oyun Seçin',
    serverDefault: 'Sunucu seçin',
    roleDefault: 'Karakter seçin',
    gameEmpty: 'Oyun listesi boş',
    serverEmpty: 'Sunucu listesi boş',
    roleEmpty: 'Karakter yok',
    server: 'Server:',
    noGameId: 'Tính năng đổi quà đang bảo trì',

    failAction: 'Yasadışı işlem',
  },
  'pt-PT': {
    0: 'Atividade não existe',
    '-1001': 'Solicitando muito frequen',
    '-10000': 'Erro de Parâmetro',
    '-20002': 'Não há caractere',
    '-10001': 'Código inválido',
    '-10002': 'Manutenção',
    '-10004': 'Manutenção',
    '-10005': 'Caractere não encontrado',
    '-10006': 'Jogo inválido',
    '-10007': 'Você não pode reivindicar novamente',
    '-10008': 'Falha ao enviar',
    '-10009': 'Faça o login e tente novamente',
    '-10010': 'Falha ao enviar. Tente novamente mais tarde.',
    '-10011': 'Número de série inválido',
    '-10012': 'Número de série expirado',
    '-10013': 'Número de série foi usado',
    '-20007': 'O código foi usado',
    10000: 'Enviado',
    codePlaceholder: 'Inserir número de série',
    verifyPlaceholder: 'Código de verificação',
    uidPlaceholder: 'Inserir UID',

    buttonText: 'Resgatar',
    ruleTitle: 'Nota',
    ruleText: [
      '1. Item será enviado para sua bolsa no jogo uma vez que o número de série tenha sido usado.',
      '2. Leia atentamente as regras antes de usar um número de série.',
      '3. A equipe de operação da {mainHostName} se reserva o direito de interpretar as políticas deste evento.',
    ],
    exchangeValError: 'Por favor insira o número de série do pacote',
    verifyCode: 'Por favor insira o código de verificação',
    exchangeSucc: 'Resgate bem-sucedido',
    exchangeTitle: 'Troca de código de presente',
    logout: 'Sair',
    logIn: 'Faça login',
    gameDefault: 'Selecione o jogo',
    serverDefault: 'Selecione o servidor',
    roleDefault: 'Selecione o personagem',
    gameEmpty: 'Lista de jogos está vazia',
    serverEmpty: 'Lista de servidores está vazia',
    roleEmpty: 'Nenhum personagem',
    server: 'Servidora:',
    noGameId: 'Tính năng đổi quà đang bảo trì',

    failAction: 'Operação ilegal',
  },
  'de-DE': {
    0: 'Aktivität existiert nicht',
    '-1001': 'Zu häufig anfordern',
    '-10000': 'Parameterfehler',
    '-20002': 'Kein Charakter',
    '-10001': 'Ungültiger Code',
    '-10002': 'Wartung',
    '-10004': 'Wartung',
    '-10005': 'Charakter nicht gefunden',
    '-10006': 'Ungültiger Name',
    '-10007': 'Du kannst nicht wiederholt abholen',
    '-10008': 'Fehlgeschalgen zu schicken',
    '-10009': 'Bitte einloggen und wieder versuchen',
    '-10010': 'Fehlgeschlagen zu schicken. Versuch wieder später.',
    '-10011': 'Ungültige Seriennummer',
    '-10012': 'Seriennummer abgelaufen',
    '-10013': 'Seriennummer wurde verwendet',
    '-20007': 'Code wurde verwendet.',
    10000: 'Geschickt',
    codePlaceholder: 'Seriennummer eingeben',
    verifyPlaceholder: 'Bestätigungscode',
    uidPlaceholder: 'UID einfügen',

    buttonText: 'Einlösen',
    ruleTitle: 'Hinweis',
    ruleText: [
      '1. Der Gegenstand wird im Spiel an deine Tasche geschickt, sobald die Seriennummer verwendet wird.',
      '2. Bitte lies die Regeln sorgfältig durch, bevor du eine Seriennummer verwendest.',
      '3. {mainHostName}-Operationsteam behält sich das Recht vor, die Richtlinien dieses Events zu interpretieren.',
    ],
    exchangeValError: 'Bitte geben Sie die Seriennummer des Pakets ein',
    verifyCode: 'Bitte geben Sie den Bestätigungscode ein',
    exchangeSucc: 'Erfolgreiche Erlösung',
    exchangeTitle: 'Gutscheincode austauschen',
    logout: 'Ausloggen',
    logIn: 'Einloggen',
    gameDefault: 'Spiel auswählen',
    serverDefault: 'Server auswählen',
    roleDefault: 'Charakter auswählen',
    gameEmpty: 'Spieleliste ist leer',
    serverEmpty: 'Serverliste ist leer',
    roleEmpty: 'Kein Charakter',
    server: 'Server:',
    noGameId: 'Tính năng đổi quà đang bảo trì',

    failAction: 'Ilegale Operation',
  },
  'ja-JP': {
    0: '活動が存在しません',
    '-1001': '操作エラー',
    '-10000': 'パラメーターエラー',
    '-20002': 'キャラクターが存在しません',
    '-10001': '認証コードエラー',
    '-10002': 'メインテナンス中、報酬交換できません',
    '-10004': 'メインテナンス中、報酬交換できません',
    '-10005': 'キャラクターが存在しません',
    '-10006': 'シリアルナンバーエラー',
    '-10007': '受け取れません',
    '-10008': '送信失敗',
    '-10009': 'ログイン後に、リトライしてください',
    '-10010': '送信失敗、リトライしてください',
    '-10011': 'シリアルナンバーエラー',
    '-10012': 'シリアルナンバー期限切れ',
    '-10013': 'シリアルナンバー使用済',
    '-20007': 'このギフトコードは使用上限に達しました',
    10000: '送信成功',
    codePlaceholder: 'シリアルナンバー',
    verifyPlaceholder: '認証コード',
    uidPlaceholder: 'UIDを入力してください',

    buttonText: '交換',
    ruleTitle: '注意事項',
    ruleText: [
      '1.コード確認後、アイテムはゲーム内のバッグに配布致します',
      '2.シリアルナンバーは使用規則をご確認いただき、正しく使用してください。',
      '3.最終的な決定権は{mainHostName}運営に属する',
    ],
    exchangeValError: 'パッケージのシリアル番号を入力してください',
    verifyCode: '確認コードを入力してください',
    exchangeSucc: '引き換え成功',
    exchangeTitle: 'ギフトコード交換',
    logout: 'ログアウト',
    logIn: 'ログイン',
    gameDefault: 'ゲームを選択してください',
    serverDefault: 'サーバーを選択してください',
    roleDefault: 'キャラクター名を選択してください',
    gameEmpty: 'ゲームリストに何もありません',
    serverEmpty: 'サーバーリストに何もありません',
    roleEmpty: 'キャラクター未作成',
    server: 'サーバー:',
    noGameId: 'Tính năng đổi quà đang bảo trì',

    failAction: '操作エラー',
  },
  'pl-PL': {
    0: 'Nie znaleziono wydarzenia',
    '-1001': 'Zbyt częsta rejestracja',
    '-10000': 'Nieprawidłowe parametry',
    '-20002': 'Brak postaci',
    '-10001': 'Nieprawidłowy kod weryfikacyjny',
    '-10002':
      'Nie można zrealizować zamówienia, gra jest w trakcie konserwacji. ',
    '-10004':
      'Nie można zrealizować zamówienia, serwer jest w trakcie konserwacji. ',
    '-10005': 'Nie znaleziono postaci',
    '-10006': 'Nieprawidłowy kod odbioru ',
    '-10007': 'Przekroczenie limitu roszczeń',
    '-10008': 'Nie udało się wysłać',
    '-10009': 'Proszę zalogować się na swoją postać i spróbować ponownie.',
    '-10010':
      'Nie udało się wysłać. Proszę zalogować się na swoją postać i spróbować ponownie.',
    '-10011': 'Nieprawidłowy kod odbioru',
    '-10012': 'Kod odbioru wygasł',
    '-10013': 'Kod odbioru już został wykorzystany',
    '-20007': 'Kod został użyty',
    10000: 'Wysłano',
    codePlaceholder: 'Wprowadź kod odbioru',
    verifyPlaceholder: 'Kod Weryfikacji',
    uidPlaceholder: 'Nhập UID',

    buttonText: 'Odbiór',
    ruleTitle: 'Uwaga',
    ruleText: [
      '1. Przedmioty zostaną wysłane do twojej torby w grze po aktywacji kodu wykupu.',
      '2. Proszę przeczytać zasady korzystania z kodu wykupu, aby uniknąć niepowodzenia aktywacji.',
      '3. Wszystkie prawa zastrzeżone przez {mainHostName} Zespół Operacyjny. ',
    ],
    exchangeValError: 'Wprowadź kod odbioru',
    verifyCode: 'Wprowadź kod weryfikacji',
    exchangeSucc: 'Odebrano',
    exchangeTitle: 'Odbierz',
    logout: 'Wyloguj',
    logIn: 'Zaloguj',
    gameDefault: 'Wybierz grę',
    serverDefault: 'Wybierz serwer',
    roleDefault: 'Wybierz postać',
    gameEmpty: 'Lista gier jest pusta',
    serverEmpty: 'Lista serwerów jest pusta',
    roleEmpty: 'Postać nie jest stworzona',
    server: 'Serwer: ',
    noGameId: 'Tính năng đổi quà đang bảo trì',

    failAction: 'Nielegalne działanie',
  },
  'ar-SA': {
    0: 'الحدث غير موجود',
    '-1001': 'طلب شديد التكرار',
    '-10000': 'خطأ بالمُعامِل',
    '-20002': 'لا يوجد شخصية',
    '-10001': 'رمز غير صحيح',
    '-10002': 'قيد الصيانة',
    '-10004': 'قيد الصيانة',
    '-10005': 'لم يمكن العثور على شخصية',
    '-10006': 'لعبة غير صالحة',
    '-10007': 'لن يمكنك الاستلام ثانية',
    '-10008': 'فشل الإرسال',
    '-10009': 'يرجى تسجيل الدخول وإعادة المحاولة',
    '-10010': 'فشل الإرسال، يرجى إعادة المحاولة لاحقًا.',
    '-10011': 'رقم مسلسل غير صحيح',
    '-10012': 'انتهت صلاحية الرقم المسلسل',
    '-10013': 'تم استخدام الرقم المسلسل',
    '-20007': 'تم استخدام الرمز',
    10000: 'تم الإرسال',
    codePlaceholder: 'يرجى إدخال الرقم المسلسل',
    verifyPlaceholder: 'الرمز',
    uidPlaceholder: 'أدخِل الـUID',

    buttonText: 'استلام',
    ruleTitle: 'ملحوظة',
    ruleText: [
      '1. سيتم إرسال الأدوات إلى حقيبتك باللعبة بمجرد استخدام الرقم المسلسل.',
      '2. يرجى قراءة القواعد بعناية قبل استخدام الرقم المسلسل.',
      '3. {mainHostName} جميع حقوق التأويل الخاصة بهذا الحدث محفوظة للفريق الإداري.',
    ],
    exchangeValError: 'يرجى إدخال الرقم المسلسل الخاص بالباقة',
    verifyCode: 'يرجى إدخال رمز التحقق',
    exchangeSucc: 'تم الاستبدال بنجاح',
    exchangeTitle: 'استبدال رموز الهدايا',
    logout: 'تسجيل الدخول',
    logIn: 'تسجيل الخروج',
    gameDefault: 'اختر اللعبة',
    serverDefault: 'اختر الخادم',
    roleDefault: 'اختر الشخصية',
    gameEmpty: 'قائمة الألعاب فارغة',
    serverEmpty: 'قائمة الخوادم فارغة',
    roleEmpty: 'لا يوجد شخصية',
    server: 'الخادم:',
    noGameId: 'Tính năng đổi quà đang bảo trì',

    failAction: 'عملية غير قانونية',
  },
};

let pageLanguage = 'en-US';
const RTL_LANG_LIST = ['ar-SA'];

export const init = lang => {
  if (lang && LANGUAGE_LIST[lang]) {
    pageLanguage = lang;
    // 切换iframe语言
    $('.j-uid-iframe').html(`
          <iframe src="https://main.d86e3of8aortq.amplifyapp.com/uid_exchange_page/?gameId=${window.gameId || 274}&language=${lang}" frameborder="0" class="uid" style="
            width: 100%;
            height: 100%;
      "></iframe>
      `)
  }
  updatePageDirection();
};

const updatePageDirection = () => {
  let isRltLang = RTL_LANG_LIST.includes(pageLanguage);
  document.documentElement.setAttribute('dir', isRltLang ? 'rtl' : 'ltr');
  isRltLang
    ? document.getElementById('uid-guide-btn').classList.add('rlt')
    : document.getElementById('uid-guide-btn').classList.remove('rlt');
};

export const get = key => {
  return (
    LANGUAGE_LIST[pageLanguage][key] ||
    LANGUAGE_LIST[pageLanguage]['-10008'] + '(' + key + ')'
  );
};
